export default function trainingMediaListDirective() {
  return {
    template: require('./training-media-list.html'),
    controller: 'TrainingMediaListController',
    controllerAs: 'trainingMediaListVM',
    bindToController: true,
    scope: {
      topics: '=',
      selectedTopicId: '=',
      selectedSectionId: '=',
      filterText: '=',
      documentsVisible: '=',
      videosVisible: '=',
      presentationsVisible: '=',
      noMedia: '=',
    },
    replace: true,
  };
}
